import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '../../assets/js/LanguageContext';

const SHOW_AFTER_SCROLL_Y = 420;

const ScrollToTopButton = () => {
    const location = useLocation();
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const updateVisibility = () => {
            setIsVisible(window.scrollY > SHOW_AFTER_SCROLL_Y);
        };

        updateVisibility();
        window.addEventListener('scroll', updateVisibility, { passive: true });

        return () => {
            window.removeEventListener('scroll', updateVisibility);
        };
    }, []);

    useEffect(() => {
        setIsVisible(window.scrollY > SHOW_AFTER_SCROLL_Y);
    }, [location.pathname]);

    const { t } = useLanguage();

    const handleScrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <button
            type="button"
            className={`scroll-to-top-button${isVisible ? ' is-visible' : ''}`}
            onClick={handleScrollToTop}
            aria-label={t('scroll_to_top')}
            title={t('scroll_to_top')}
        >
            <svg
                className="scroll-to-top-button__icon"
                viewBox="0 0 64 64"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
            >
                <rect className="scroll-to-top-button__bg" x="8" y="8" width="48" height="48" rx="18" />
                <path
                    d="M32 43V21M32 21L22.5 30.5M32 21L41.5 30.5"
                    stroke="#ffffff"
                    strokeWidth="5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </button>
    );
};

export default ScrollToTopButton;
